import axios from "axios";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { isLoggedIn } from "../utils";

const AdminContext = createContext();

export const AdminContextProvider = ({ children, value }) => {
  const [userProfile, setUserProfile] = useState({});
  return (
    <AdminContext.Provider
      value={{ userProfile: userProfile, setUserProfile: setUserProfile }}
    >
      {children}
    </AdminContext.Provider>
  );
};

export const useAdminAuth = () => {
  return useContext(AdminContext);
};

// get user profile
export const getUserProfile = async (setUserProfile) => {
  //**********get pharmacist detail by id**********/
  const token = isLoggedIn().token;

  try {
    // const { data } = await axios({
    //   url: `${process.env.REACT_APP_API_URL}/setting/profile_detail`,
    //   method: "GET",
    //   headers: {
    //     Authorization: "Bearer " + token,
    //     Accept: "application/json",
    //     "Content-Type": "application/json",
    //   },
    // });
    // if (data.status === 200) {
    //   setUserProfile(data.data.profile);
    // } else {
    //   toast.error(data.message);
    // }
    setUserProfile({
      name: "neptune",
      userName: "community",
    });
  } catch (err) {
    toast.error(err?.response?.data?.message || err.message);
  }
};

// Chats Context

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [user, setUser] = useState({});

  // pharmacist chat state
  const [selectedChat, setSelectedChat] = useState({});
  const [notification, setNotification] = useState([]);
  const [chats, setChats] = useState([]);

  // user chat state
  const [selectedUserChat, setSelectedUserChat] = useState({});
  const [userNotification, setUserNotification] = useState([]);
  const [userChats, setUserChats] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("neptuneAdmin"));

    setUser(userInfo);
  }, [navigate]);

  return (
    <ChatContext.Provider
      value={{
        selectedChat,
        setSelectedChat,
        user,
        setUser,
        notification,
        setNotification,
        chats,
        setChats,
        selectedUserChat,
        setSelectedUserChat,
        userNotification,
        setUserNotification,
        userChats,
        setUserChats,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const useChatState = () => {
  return useContext(ChatContext);
};
